<title>{{ profilePage.htmlTitle }}</title>
<app-banner [banner]="profilePage.banner" [userName]="bannerWelcomeName" [isDefaultPageBanner]="false" [isWelcomeUserBanner]="true"></app-banner>

<div class="bagel-profile-page" *ngIf="showPreferences">
  <h1 class="page-title">My Profile</h1>
  <p class="page-subtitle">Manage your personal details and email preferences</p>

  <ba-message *ngIf="showSaveSuccessMsg" variant="success"><h4 slot="heading">Saved successfully.</h4></ba-message>

  <ba-message *ngIf="registrationError" variant="error"><h4 slot="heading">{{ registrationError }}</h4></ba-message>

  <form [formGroup]="emailPreferenceForm" (ngSubmit)="updateEmailPreference()" novalidate>

    <!-- Update Your Details -->
    <div class="card-section">
      <div class="card-header">
        <h2 class="card-heading">Update Your Details</h2>
        <p class="card-subheading">Manage your personal information</p>
      </div>
      <div class="card-body">
        <ba-input-text
          label="First Name"
          [attr.value]="emailPreferenceForm.get('firstName')?.value"
          required="true"
          min-length="2"
          max-length="30"
          (baOnInput)="onTextInput($event, 'firstName')">
        </ba-input-text>
        <div class="field-error" *ngIf="submitted && f['firstName'].errors">
          First name must be at least 2 characters long &amp; no longer than 30 characters.
        </div>
        <ba-input-text
          label="Last Name"
          [attr.value]="emailPreferenceForm.get('lastName')?.value"
          required="true"
          min-length="2"
          max-length="30"
          (baOnInput)="onTextInput($event, 'lastName')">
        </ba-input-text>
        <div class="field-error" *ngIf="submitted && f['lastName'].errors">
          Last name must be at least 2 characters long &amp; no longer than 30 characters.
        </div>
        <ba-input-email
          label="Email ID"
          [attr.value]="user?.userEmail"
          aria-disabled="true"
          required="true"
          (keydown)="onEmailKeydown($event)">
        </ba-input-email>
      </div>
    </div>

    <!-- Email Preferences (parent container) -->
    <div class="card-section">
      <div class="card-header">
        <h2 class="card-heading">Email Preferences</h2>
        <p class="card-subheading">Choose which email notifications you'd like to receive</p>
      </div>
      <div class="card-body">

        <!-- General Communications -->
        <ba-accordion heading="General Communications" [attr.open]="true">
          <div class="checkbox-item">
            <ba-checkbox
              label="NDC Commercial News"
              [attr.checked]="emailPreferenceForm.get('NDCCommercialNews')?.value"
              (baChange)="onCheckboxChange($event, 'NDCCommercialNews')">
            </ba-checkbox>
            <p class="checkbox-description">Commercial announcements, partner news and general updates about BA's NDC programme</p>
          </div>
          <div class="checkbox-item">
            <ba-checkbox
              label="IAG Portal Users"
              [attr.checked]="emailPreferenceForm.get('IAGPortalUsers')?.value"
              (baChange)="onCheckboxChange($event, 'IAGPortalUsers')">
            </ba-checkbox>
            <p class="checkbox-description">Information and announcements for registered IAG portal users</p>
          </div>
        </ba-accordion>

        <!-- Technical Updates -->
        <ba-accordion heading="Technical Updates" [attr.open]="true">
          <div class="checkbox-item">
            <ba-checkbox
              label="NDC Platform Update"
              [attr.checked]="emailPreferenceForm.get('platformUpdates')?.value"
              (baChange)="onCheckboxChange($event, 'platformUpdates')">
            </ba-checkbox>
            <p class="checkbox-description">API changes, release notes, technical behaviours and integration updates</p>
          </div>
          <div class="checkbox-item">
            <ba-checkbox
              label="Technical Operational Alerts"
              [attr.checked]="emailPreferenceForm.get('TechnicalOperationalAlerts')?.value"
              (baChange)="onCheckboxChange($event, 'TechnicalOperationalAlerts')">
            </ba-checkbox>
            <p class="checkbox-description">Live operational notifications relevant to API performance, outages or urgent announcements</p>
            <div class="nested-checkboxes">
              <div class="checkbox-item">
                <ba-checkbox
                  label="17.2"
                  [attr.checked]="emailPreferenceForm.get('operationalOldAPIUpdates')?.value"
                  (baChange)="onCheckboxChange($event, 'operationalOldAPIUpdates')">
                </ba-checkbox>
                <p class="checkbox-description">Receive live operational alerts for 17.2</p>
              </div>
              <div class="checkbox-item">
                <ba-checkbox
                  label="21.3"
                  [attr.checked]="emailPreferenceForm.get('operationalNewAPIUpdates')?.value"
                  (baChange)="onCheckboxChange($event, 'operationalNewAPIUpdates')">
                </ba-checkbox>
                <p class="checkbox-description">Receive live operational alerts for 21.3</p>
              </div>
            </div>
          </div>
        </ba-accordion>

      </div>
    </div>

    <!-- Save Button -->
    <div class="action-bar">
      <ba-button variant="primary" (click)="updateEmailPreference()">Save Changes</ba-button>
    </div>

  </form>
</div>
